import React, { useEffect, useState } from "react";


interface Size {
    width: number;
    height: number;
}

const useResize = () => {
   
    const [size, setSize] = useState<Size>();

    const resizeHanlder = () => {
        if (typeof window !== "undefined") {
            const width =  window.innerWidth;
            const height = window.innerHeight;
        
            setSize({
            width: width,
            height: height,
            });
        }
    };

    useEffect(() => {
        window.addEventListener('resize', resizeHanlder);
        // Cleanup function
        return () => {
        window.removeEventListener('resize', resizeHanlder);
        }
    }, []);
    
    return size;
}

export default useResize;